import swiper from 'swiper/dist/js/swiper'
import 'swiper/dist/css/swiper.min'
import ArcText from 'arc-text'


document.addEventListener('DOMContentLoaded', () => {
    var testimonialSlider = document.querySelector('.testimonials-slider-container')
    
    if (document.body.contains(testimonialSlider)) {
        var arcText = document.getElementById('testimonial-title')

        var sliderEl = '.testimonials-slider-container', 
            sliderOptions = {
            loop: true,
            centeredSlides: true,
            breakpointsInverse: true,
            breakpoints: {
                // when window width is >= 320px
                320: {
                    slidesPerView: 1,
                },
                // when window width is >= 480px
                480: {
            
                },
                // when window width is >= 640px
                1024: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                },
            }
        }
        var testimonialSlider = new swiper(sliderEl, sliderOptions)

        testimonialSlider.init()


        var arcText = new ArcText(document.getElementById('testimonial-title'))

        // Set the radius to 150 pixels.
        arcText.arc(1200)
        arcText.forceWidth(true)
    }
})
